import { IStoreState } from 'modules/types';

export const getSettings = (state: IStoreState) => state.settings.config;
export const getLayout = (state: IStoreState) => state.settings.layout;
export const getMobileModde = (state: IStoreState) => state.settings.mobileView;

export const getRoute = (state: IStoreState) => state.settings.route;
